(function() {
  var section = document.querySelector('.collection-products');
  if (!section) return;

  var toggleBtn = section.querySelector('[data-filter-toggle]');
  var closeBtn = section.querySelector('[data-filter-close]');
  var overlay = section.querySelector('[data-filter-overlay]');
  var panel = section.querySelector('[data-filter-panel]');
  var applyBtn = section.querySelector('[data-filter-apply]');
  var resetBtn = section.querySelector('[data-filter-reset]');
  var sheetCloseBtn = section.querySelector('[data-filter-sheet-close]');

  if (!toggleBtn || !panel) return;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function openPanel() {
    var scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
    panel.classList.add('is-open');
    overlay.classList.add('is-open');
    if (sheetCloseBtn) sheetCloseBtn.classList.add('is-open');
  }

  function closePanel() {
    panel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    if (sheetCloseBtn) sheetCloseBtn.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  toggleBtn.addEventListener('click', openPanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlay) overlay.addEventListener('click', closePanel);
  if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      closePanel();
    }
  });

  // Collapsible section toggles
  section.querySelectorAll('[data-filter-section-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.closest('[data-filter-section]').classList.toggle('is-open');
    });
  });

  // Apply filters
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var url = new URL(window.location.href);

      // Clear all existing filter, sort, and page params
      var keysToDelete = [];
      url.searchParams.forEach(function(val, key) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach(function(key) {
        url.searchParams.delete(key);
      });

      // List/boolean filters (checkboxes with name starting with "filter.")
      panel.querySelectorAll('input[type="checkbox"]:checked').forEach(function(input) {
        if (input.name.startsWith('filter.')) {
          url.searchParams.append(input.name, input.value);
        }
      });

      // Price range inputs
      panel.querySelectorAll('[data-price-range-filter]').forEach(function(priceBlock) {
        var minInput = priceBlock.querySelector('[data-price-min]');
        var maxInput = priceBlock.querySelector('[data-price-max]');
        if (minInput && minInput.value !== '' && Number(minInput.value) > 0) {
          url.searchParams.set(minInput.name, minInput.value);
        }
        if (maxInput && maxInput.value !== '' && Number(maxInput.value) > 0) {
          url.searchParams.set(maxInput.name, maxInput.value);
        }
      });

      // Sort
      var sortInput = panel.querySelector('input[name="sort_by"]:checked');
      if (sortInput) {
        url.searchParams.set('sort_by', sortInput.value);
      }

      window.location.href = url.toString();
    });
  }

  // Reset filters
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      window.location.href = window.location.pathname;
    });
  }
})();
